import { GLOBAL_LIMIT_DATE_QUERY } from 'redux/actions';
import { IAction } from 'interfaces/common';
import { ILimitDateQuery } from 'interfaces/api';
import { call, put, takeLatest } from 'redux-saga/effects';
import config from 'config';

const getLimitDateQuery = (): Promise<Response> | null => {
  const headers = new Headers();

  headers.append('pragma', 'no-cache');
  headers.append('cache-control', 'no-cache');

  return fetch(config.limitQueryUrl, {
    method: 'GET',
    headers,
  })
    .then((res) => {
      if (res.status === 304) {
        return [];
      }
      return res.json();
    })
    .catch((err) => console.error('getLimitDateQuery', err));
};

function* doGetLimitDateQuery(request: IAction<undefined>) {
  let limitQuery: ILimitDateQuery[] = [];

  try {
    limitQuery = yield call(getLimitDateQuery);

    yield put({
      type: request.response?.success,
      payload: limitQuery
    });
  } catch (err) {
    console.log('error getLimitDateQuery', err);

    yield put({
      type: request.response?.failed,
      payload: [],
    });
  }
}

export function* watchGetLimitDateQuery() {
  yield takeLatest(GLOBAL_LIMIT_DATE_QUERY, doGetLimitDateQuery);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Account/LimitDateQuery.ts